interface PromoCodeSectionProps {
  promo: string;
  busy: boolean;
  onPromoChange: (value: string) => void;
  onRedeem: () => void;
}

export function PromoCodeSection({ promo, busy, onPromoChange, onRedeem }: PromoCodeSectionProps) {
  return (
    <div className="promo-section">
      <label className="field-label" htmlFor="promo-code">Have a promo code?</label>
      <div className="promo-row">
        <input
          id="promo-code"
          value={promo}
          onChange={(e) => onPromoChange(e.target.value)}
          placeholder="PROMO CODE"
          className="field-input promo-input"
        />
        <button className="btn-primary" disabled={busy || !promo.trim()} onClick={onRedeem}>
          Redeem
        </button>
      </div>
      <p className="promo-hint">
        A valid code unlocks the Family plan free for one year.
      </p>
    </div>
  );
}
